import store from '@/store';
import axios from 'axios';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Endpoints } from '@/ts/store/Constants';
import CorporationData from '@/ts/CorporationData';
import { CorporationDataResponse } from '@/ts/HococoInterfaces';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'Corporations', namespaced: true})
export default class Corporations extends VuexModule {
    public corporations: CorporationData[] = [];
    public corporationsMap: { [index: number]: number } = {};
    public corporationId: number = 0;
    public currentCorporation: any = null;
    public corporationSquareLogoURL: string = null;

    @Mutation
    public RESET_CORPORATIONS_STORE_STATE(): void {
        this.corporations             = [];
        this.corporationsMap          = {};
        this.corporationId            = 0;
        this.currentCorporation       = null;
        this.corporationSquareLogoURL = null;
    }

    /**
     * @deprecated getCurrentCorporation method should be used instead
     */
    get allCorporations() {
        return this.corporations;
    }

    get getCurrentCorporation() {
        return this.currentCorporation;
    }

    get getCorporation() {
        return (corporationId: number) => {
            return this.corporations[this.corporationsMap[corporationId]];
        };
    }

    get getCorporationSquareLogoURL(): string {
        return this.corporationSquareLogoURL;
    }

    @Action
    public FETCH_CORPORATIONS() {
        axios.get(Endpoints.Admin.Corporations.CORPORATIONS_LIST)
            .then((response) => {
                store.commit(Mutations.ADD_CORPORATIONS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
        return;
    }

    @Action
    public FETCH_ADMIN_CURRENT_CORPORATION() {
        axios.get(Endpoints.Admin.Corporations.CURRENT_CORPORATION)
            .then((response) => {
                store.commit(Mutations.SET_ADMIN_CURRENT_CORPORATION, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
        return;
    }

    @Action
    public UPDATE_CORPORATION_CONFIGS(data: any) {
        const requestPayload = new FormData();
        requestPayload.append('corporationId', data.corporationId);
        requestPayload.append('primaryColor', data.primaryColor);
        requestPayload.append('secondaryColor', data.secondaryColor);
        requestPayload.append('primaryLogo', data.mainLogo);
        requestPayload.append('squireLogo', data.squireLogo);
        requestPayload.append('smsOption', data.smsOption);
        requestPayload.append('expirationInterval', data.expirationInterval);
        requestPayload.append('reminderInterval', data.reminderInterval);
        requestPayload.append('reminderResponseInterval', data.reminderResponseInterval);
        requestPayload.append('responseDeadlineInterval', data.responseDeadlineInterval);

        axios.post(Endpoints.Admin.Corporations.CORPORATION_CONFIGS, requestPayload)
            .then((response) => {
                store.commit(Mutations.SET_ADMIN_CURRENT_CORPORATION, response.data);
                store.commit(Mutations.CHANGE_CORPORATION_SMS_OPTION, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public ADD_CORPORATIONS(corporationData: CorporationDataResponse[]): void {
        this.corporations    = [];
        this.corporationsMap = {};

        for (const corporation of corporationData) {
            let arrayIndex = null;

            if (!this.corporationsMap.hasOwnProperty(corporation.id)) {
                arrayIndex = this.corporations.push(new CorporationData(
                    corporation.id,
                    corporation.name,
                    corporation.sms,
                    corporation.defaultLanguage
                )) - 1;

                this.corporationId = corporation.id;
                this.corporationsMap[corporation.id] = arrayIndex;
            }
        }
    }

    @Mutation
    public SET_ADMIN_CURRENT_CORPORATION(data: any): void {
        this.currentCorporation = data;
    }

    @Mutation
    public SET_CORPORATION_SQUARE_LOGO_URL(logoURL: string): void {
        this.corporationSquareLogoURL = logoURL;
    }

    @Mutation
    public CHANGE_CORPORATION_SMS_OPTION(data: any): void {
        const corporation = this.corporations.find((c: any) => c.id === data.id);
        corporation.sms = data.sms ? 1 : 0;
    }
}
